import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import {
  CustomQuestionSaveButton,
  ReportCustomQuestionTypePropsBase,
  StyledCustomQuestionType,
  htmlToPlainText,
} from './utils';
import CustomQuestionTop from './CustomQuestionTop';
import { useSaveSurveyAnswer } from './hooks';
import CustomQuestionShow from './CustomQuestionShow';
import TrueImpactTextfield from 'shared/design-system/components/TrueImpactTextfield';

const StyledDiv = styled(StyledCustomQuestionType)``;

const CustomQuestionInteger: React.FC<ReportCustomQuestionTypePropsBase> = ({
  question,
  answer,
  disableEdit,
  initialEdit,
  saveButtonText,
  customQuestionIndex,
  customQuestion,
  questionIndex,
  reportId,
  onChange,
  handleAddDoneQuestionId,
  handleRemoveDoneQuestionId,
}) => {
  const a = answer[0] || {};
  const initialAnswer = a.value || '';
  const initialInteger =
    a.value === undefined ? undefined : Number(a.value) || 0;
  const [integer, setInteger] = useState<number | undefined>(initialInteger);
  const isValid = integer !== undefined;
  const {
    requestState,
    isEdit,
    handleShowEdit,
    handleCancelEdit,
    handleSaveSurveyAnswer,
  } = useSaveSurveyAnswer({
    onChange,
    initialAnswer,
    initialEdit,
    handleAddDoneQuestionId,
    handleRemoveDoneQuestionId,
    question,
    customQuestionIndex,
    customQuestion,
    questionIndex,
    reportId,
  });

  const handleSubmit = useCallback(() => {
    if (!isValid) return;
    handleSaveSurveyAnswer({
      answerId: a.dbId,
      answer: {
        dbId: undefined,
        optionId: undefined,
        value: integer.toString(),
      },
    });
  }, [onChange, integer, isValid]);

  const handleChange = useCallback(
    (value: string) => {
      setInteger(Number(value) || 0);
    },
    [setInteger],
  );

  const handleCancel = useCallback(() => {
    setInteger(initialInteger);
    handleCancelEdit();
  }, [initialInteger, handleCancelEdit]);

  if (disableEdit || (!isEdit && isValid)) {
    return (
      <CustomQuestionShow
        answer={{
          questionType: 'integer',
          answer: integer?.toString() || '',
        }}
        question={question}
        disableEdit={disableEdit}
        handleEdit={handleShowEdit}
      />
    );
  }

  return (
    <StyledDiv>
      <CustomQuestionTop
        title={question.questionText}
        helperText={question.helperText}
        questionType={question.questionType}
      />
      <TrueImpactTextfield
        type="number"
        value={integer}
        onChange={handleChange}
        placeholder={htmlToPlainText(question.helperText)}
      />
      <CustomQuestionSaveButton
        disabled={!isValid}
        text={saveButtonText}
        requestState={requestState}
        handleSubmit={handleSubmit}
        handleCancel={initialAnswer ? handleCancel : undefined}
      />
    </StyledDiv>
  );
};

export default CustomQuestionInteger;
